import ThirdPartyLicense from './third_party_license';

export default ThirdPartyLicense;
